module.exports = __webpack_public_path__ + "img/vaginal-dryness.378988af.svg";